import { render, staticRenderFns } from "./MerchantRewards.vue?vue&type=template&id=332d5a45&"
import script from "./MerchantRewards.vue?vue&type=script&lang=js&"
export * from "./MerchantRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports